import { render, staticRenderFns } from "./InterneerfassungModal.vue?vue&type=template&id=672c4f3a"
import script from "./InterneerfassungModal.vue?vue&type=script&lang=js"
export * from "./InterneerfassungModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports